import React, { Component } from 'react'
import { LineChart, Line, XAxis, YAxis, Legend } from 'recharts'
import { benchmarkData, testData, yDomain, refAbility, refCompliance, refWeight, bikeWeight } from './data'
import Select from 'material-ui/Select'
import { MenuItem } from 'material-ui/Menu'
import Input, { InputLabel } from 'material-ui/Input'
import { FormControl } from 'material-ui/Form'
import TextField from 'material-ui/TextField'
import './App.css'

class App extends Component {
  constructor (props) {
    super(props)
    this.state = {
      weight: 75,
      abilityMult: 1,
      compliancePref: 1,
      testDataIdx: 0
    }
    this.lastData = []
    this.handleChange = this.handleChange.bind(this)
  }

  get isWeightCorrect () {
    const {weight} = this.state
    return !isNaN(weight) && weight > 30
  }

  get data () {
    if (this.isWeightCorrect) {
      const {testDataIdx, abilityMult, compliancePref, weight} = this.state
      const selectedTestData = testData[testDataIdx].data
      const selectedLowerBound = testData[testDataIdx].lowerBound
      const selectedUpperBound = testData[testDataIdx].upperBound
      const mod = ((Number(weight) + bikeWeight) * abilityMult * compliancePref) / (refWeight * refAbility * refCompliance)

      this.lastData = selectedTestData.map((y, idx) => ({
        x: idx,
        benchmark: benchmarkData[idx] * mod,
        testData: y,
        lowerBound: selectedLowerBound[idx],
        upperBound: selectedUpperBound[idx]
      }))
    }
    return this.lastData
  }

  handleChange (event) {
    this.setState({[event.target.name]: event.target.value})
  }

  render () {
    const {testDataIdx, abilityMult, compliancePref, weight} = this.state
    const testDataLabel = testData[testDataIdx].label
    return (
      <div className="App">
        <a href="https://vorsprungsuspension.com/" target="_blank" rel="noopener noreferrer"><img className="logo" alt="logo" src="logo.png" /></a>
        <div className="subtitle">YouTune Calculator - Fractive Valve</div>
        <div className="input">
          <FormControl>
            <InputLabel htmlFor="Data">Valving Setup</InputLabel>
            <Select
              className="widget"
              value={testDataIdx}
              input={<Input name="testDataIdx" id="data"/>}
              onChange={this.handleChange}
            >
              {
                testData.map((testDataInfo, idx) =>
                  <MenuItem key={idx} value={idx}>{testDataInfo.label}</MenuItem>
                )
              }
            </Select>
          </FormControl>
        </div>
        <div className="input">
          <TextField
            className="text-input"
            error={!this.isWeightCorrect}
            id="weight"
            label="Rider Weight in kg"
            value={weight}
            name="weight"
            onChange={this.handleChange}
          />
        </div>
        <div className="input">
          <FormControl>
            <InputLabel htmlFor="ability-level">Level of Aggression</InputLabel>
            <Select
              className="widget"
              value={abilityMult}
              input={<Input name="abilityMult" id="ability-level"/>}
              onChange={this.handleChange}
            >
              <MenuItem value={0.9}>Moderate</MenuItem>
              <MenuItem value={0.95}>Medium</MenuItem>
              <MenuItem value={1.0}>High</MenuItem>
              <MenuItem value={1.05}>Very High</MenuItem>
            </Select>
          </FormControl>
        </div>
         <div className="input">
          <FormControl>
            <InputLabel htmlFor="compliance-pref">Compliance Preference</InputLabel>
            <Select
              className="widget"
              value={compliancePref}
              input={<Input name="compliancePref" id="compliance-pref"/>}
              onChange={this.handleChange}
            >
              <MenuItem value={0.9}>Very Compliant</MenuItem>
              <MenuItem value={0.95}>Compliant</MenuItem>
              <MenuItem value={1.0}>Balanced</MenuItem>
              <MenuItem value={1.05}>Supportive</MenuItem>
              <MenuItem value={1.15}>Very Supportive</MenuItem>
            </Select>
          </FormControl>
        </div>
        <div className="chart">
          <LineChart width={500} height={350} data={this.data}>
            <XAxis dataKey="x" tick={false} label="Velocity"/>
            <YAxis tick={false} domain={yDomain} label="Force"/>
            <Line type="monotone" dataKey="testData" name={testDataLabel} stroke="#ff2200" strokeWidth={1.5} dot={false}/>
            <Line type="monotone" dataKey="lowerBound" name={"Lower Bound"} stroke="#ffc8c8" dot={false}/>
            <Line type="monotone" dataKey="upperBound" name={"Upper Bound"} stroke="#ffc8c8" dot={false}/>
            <Line type="monotone" dataKey="benchmark" name="Recommended" stroke="#8884d8" strokeWidth={2} dot={false}/>
            <Legend verticalAlign="top"/>
          </LineChart>
        </div>
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js